import { apiClient } from './client';

const BASE = '/api/reports/transcripts';

export const transcriptApi = {
  getTranscript: async (sessionId, lang = 'en') => {
    const response = await apiClient.get(`${BASE}/${sessionId}`, { params: { lang } });
    return response.data;
  },

  /** One page of segments, without `words` unless `params.include = 'words'`. */
  getTranscriptSegments: async (sessionId, params = {}, lang = 'en') => {
    const response = await apiClient.get(`${BASE}/${sessionId}/segments`, {
      params: { ...params, lang },
    });
    return response.data;
  },

  /** Word timestamps for the given segments; the editor loads them for visible blocks only. */
  getSegmentWords: async (sessionId, segmentIds, lang = 'en') => {
    const response = await apiClient.get(`${BASE}/${sessionId}/words`, {
      params: { segment_ids: segmentIds.join(','), lang },
    });
    return response.data;
  },

  updateTranscript: async (sessionId, transcriptData, lang = 'en') => {
    const response = await apiClient.put(`${BASE}/${sessionId}`, transcriptData, { params: { lang } });
    return response.data;
  },

  /** Applies edit ops in one transaction. 409 means the transcript is not row-stored yet; use PUT. */
  patchTranscriptSegments: async (sessionId, ops, lang = 'en') => {
    const response = await apiClient.patch(`${BASE}/${sessionId}/segments`, { ops }, { params: { lang } });
    return response.data;
  },

  renameSpeaker: async (sessionId, oldName, newName, lang = 'en') => {
    const response = await apiClient.put(`${BASE}/${sessionId}/speakers/rename`, null, {
      params: { old_name: oldName, new_name: newName, lang },
    });
    return response.data;
  },

  deleteSpeaker: async (sessionId, speakerName, mergeToSpeaker, lang = 'en') => {
    const response = await apiClient.delete(`${BASE}/${sessionId}/speakers/${speakerName}`, {
      params: { merge_to_speaker: mergeToSpeaker, lang },
    });
    return response.data;
  },

  acquireLock: async (sessionId, force = false) => {
    const response = await apiClient.post(`${BASE}/${sessionId}/lock`, null, { params: { force } });
    return response.data;
  },

  forceOverrideLock: (sessionId) => transcriptApi.acquireLock(sessionId, true),

  releaseLock: async (sessionId) => {
    const response = await apiClient.delete(`${BASE}/${sessionId}/lock`);
    return response.data;
  },

  getLockStatus: async (sessionId) => {
    const response = await apiClient.get(`${BASE}/${sessionId}/lock-status`);
    return response.data;
  },

  listMissions: async () => {
    const response = await apiClient.get(`${BASE}/missions`);
    return response.data;
  },

  sendToMission: async (sessionId, mission, { lang = 'en', includeWords = true, title } = {}) => {
    const response = await apiClient.post(`${BASE}/${sessionId}/send-missions`, null, {
      params: { mission, lang, include_words: includeWords, ...(title ? { title } : {}) },
    });
    return response.data;
  },
};
